import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { isMobile, isTabletDown } from './isMobile';

history.scrollRestoration = 'manual';
ScrollTrigger.defaults({
    scroller: document.body
});

import 'cookieconsent';
import './slider';
import './header';
import './popup';
import './mobile-menu';
import { Accordion } from './accordion';
import { SnapperInstance } from './snapper';
import { HeroScene } from './hero-scene';
import { HeroSecondScene } from './hero-second-scene';
import { HeroThirdScene } from './hero-third-scene';
import { ThirdScene } from './third-scene';
import { FourScene } from './four-scene';
import { FiveScene } from './five-scene';
import { SixScene } from './six-scene';
import { SevenScene } from './seven-scene';
import { EightScene } from './eight-scene';
import { NineScene } from './nine-scene';
import { CircleScene } from './circle-scene';
import { SceneNavigator } from './sceneNavigator';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(CSSPlugin);

document.fonts.ready.then(function () {
    document.querySelectorAll('.hero-third-scene .accordion').forEach(accordion => {
        var item = new Accordion(accordion, { enableCondition: isMobile });
        item.init();
    });

    var accordion = new Accordion(document.querySelector('.eight-section .accordion'), { enableCondition: isTabletDown });
    accordion.init();

    HeroScene();
    HeroSecondScene();
    HeroThirdScene();
    ThirdScene();
    FourScene();
    FiveScene();
    SixScene();
    SevenScene();
    EightScene();
    NineScene();
    CircleScene();

    //setVh();
    SnapperInstance.init();
    //SnapperInstance.attachBackToTopTrigger(document.getElementById('back-to-top'));
    var navigator = new SceneNavigator();
    navigator.init();
});

//function setVh() {
//    let vh = window.innerHeight * 0.01;
//    document.documentElement.style.setProperty('--vh', `${vh}px`);
//}